export default [{
    text: 'Бизнес-центр',
    value: 'businessCenter',
}, {
    text: 'Торгово-развлекательный центр',
    value: 'shoppingAndEntertainmentCenter',
}, {
    text: 'Старый фонд',
    value: 'old',
}, /* {
    text: 'Офисное здание',
    value: 'officeBuilding'
}, {
    text: 'Бизнес-парк',
    value: 'businessPark'
}, {
    text: 'Офисно-производственный комплекс',
    value: 'officeIndustrialComplex'
}, {
    text: 'Офисно-складской комплекс',
    value: 'officeAndWarehouseVomplex'
}, {
    text: 'Складской комплекс',
    value: 'warehouseVomplex'
}, {
    text: 'Производственно-складской комплекс',
    value: 'industrialWarehouseVomplex'
}, {
    text: 'Логистический центр',
    value: 'logisticsCenter'
}, {
    text: 'Склад',
    value: 'warehouse'
}, {
    text: 'Административное здание',
    value: 'administrativeBuilding'
}, {
    text: 'Индустриальный парк',
    value: 'industrialPark'
}, {
    text: 'Логистический комплекс',
    value: 'logisticsComplex'
}, {
    text: 'Торгово-деловой комплекс',
    value: 'shoppingAndBusinessComplex'
}, {
    text: 'Многофункциональный комплекс',
    value: 'multifunctionalComplex'
}, {
    text: 'Офисно-жилой комплекс',
    value: 'officeAndResidentialComplex'
}, {
    text: 'Торгово-офисный комплекс',
    value: 'tradingOfficeComplex'
}, {
    text: 'Офисно-гостиничный комплекс',
    value: 'officeAndHotelComplex'
}, {
    text: 'Деловой центр',
    value: 'businessCenter2'
}, {
    text: 'Особняк',
    value: 'mansion'
}, {
    text: 'Технопарк',
    value: 'technopark'
}, {
    text: 'Бизнес-квартал',
    value: 'businessQuarter'
}, {
    text: 'Отдельно стоящее здание',
    value: 'standaloneBuilding'
}, {
    text: 'Жилой дом',
    value: 'residentialHouse'
}, {
    text: 'Жилой комплекс',
    value: 'residentialComplex'
}, {
    text: 'Торговый центр',
    value: 'shoppingCenter'
}, {
    text: 'Специализированный торговый центр',
    value: 'specializedShoppingCenter'
}, {
    text: 'Торгово-общественный центр',
    value: 'shoppingAndCommunityCenter'
}, {
    text: 'Аутлет',
    value: 'outlet'
}, {
    text: 'Производственный комплекс',
    value: 'industrialComplex'
}, {
    text: 'Промплощадка',
    value: 'industrialSite'
}, {
    text: 'Производственный цех',
    value: 'manufacturingFacility'
}, {
    text: 'Объект свободного назначения',
    value: 'freeAppointmentObject'
}, {
    text: 'Имущественный комплекс',
    value: 'propertyComplex'
}, {
    text: 'Производственное здание',
    value: 'manufactureBuilding'
}, {
    text: 'Модульное здание',
    value: 'modular'
}, {
    text: 'Свободное',
    value: 'free'
}, {
    text: 'Офисно-складское',
    value: 'officeAndWarehouse'
}, */ {
    text: 'Нежилой фонд',
    value: 'uninhabitedFund',
}, {
    text: 'Жилой фонд',
    value: 'residentialFund',
}, /* , {
    text: 'Другое',
    value: 'other'
} */ ];

// TODO раскомментировать в версии 2
